import { motion } from "framer-motion";
import { useLang } from "@/App";
import { copy } from "@/i18n";

const Moments = () => {
    const { lang } = useLang();
    const c = copy[lang].moments;

    return (
        <section id="momenti" data-testid="moments-section" className="relative py-20 lg:py-28 overflow-hidden">
            <div className="absolute top-0 left-1/4 w-[420px] h-[420px] rounded-full bg-brass/[0.07] blur-[110px] pointer-events-none" />
            <div className="max-w-7xl mx-auto px-4 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="text-center"
                >
                    <span className="text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-crimson">
                        {c.label}
                    </span>
                    <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-4xl lg:text-5xl">
                        {c.title}
                    </h2>
                    <div className="mx-auto mt-8 w-44 sm:w-52 rounded-2xl overflow-hidden border border-white/10 glow-red">
                        <video
                            data-testid="moments-drink-video"
                            autoPlay
                            muted
                            loop
                            playsInline
                            preload="metadata"
                            poster="/media/drink-pour-poster.jpg"
                            className="w-full h-auto block"
                        >
                            <source src="/media/drink-pour.webm" type="video/webm" />
                            <source src="/media/drink-pour.mp4" type="video/mp4" />
                        </video>
                    </div>
                </motion.div>

                <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
                    {c.items.map((m, i) => (
                        <motion.div
                            key={i}
                            data-testid={`moment-card-${i}`}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.12 }}
                            className="group relative bg-noir p-8 hover:bg-card transition-colors"
                        >
                            <span className="font-mono text-[11px] tracking-[0.3em] text-brass">{m.time}</span>
                            <h3 className="mt-4 font-serif italic text-3xl sm:text-4xl text-white group-hover:text-crimson-bright transition-colors">
                                {m.name[lang]}
                            </h3>
                            <p className="mt-4 text-sm text-neutral-400 leading-relaxed">{m.desc[lang]}</p>
                            <span className="absolute bottom-0 left-8 right-8 h-px bg-gradient-to-r from-crimson/0 via-crimson/60 to-crimson/0 opacity-0 group-hover:opacity-100 transition-opacity" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Moments;
